import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { ResellerResponse } from '@utils/types/organization/reseller.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

type ResellerData = {
  email: string;
  name: string;
  phone?: string;
  is_active: boolean;
};

export const useCreateResellerCustomer = () => {
  const queryClient = useQueryClient();

  const createCustomer = (resellerData: ResellerData) =>
    Axios.post<ResellerResponse>(POST_URL().createReseller, resellerData).then(
      res => res.data
    );

  return useMutation<ResellerResponse, AxiosError<BaseError>, ResellerData>(
    createCustomer,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['resellers']);
      },
      useErrorBoundary: false
    }
  );
};
